// src/App.jsx
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { NotificationProvider } from "./contexts/NotificationsContext";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProductsProvider } from './contexts/ProductsContext';
import { usePushNotifications } from './hooks/usePushNotifications';
import AuthPlatform from './ECRANS/Auth';
import OffersPage from './ECRANS/Offers';
import AccountPage from './ECRANS/Account';
import ApplicationsPage from './ECRANS/Posts';
import CrouVenteForm from './ECRANS/Sells';
import AdminDashboard from './ECRANS/Admin-dashboard';
import Layout from './components/Layout';

function PushSubscriptionManager() {
  const { isAuthenticated, userInfo } = useAuth();
  const { isSupported, isSubscribed, subscribe } = usePushNotifications();

  useEffect(() => {
    if (isSupported && isAuthenticated && userInfo && !isSubscribed) {
      const timer = setTimeout(() => {
        subscribe(userInfo).catch(err => console.error("Auto-subscribe error:", err));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isSupported, isAuthenticated, userInfo, isSubscribed, subscribe]);

  return null;
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <ProductsProvider>
          <NotificationProvider>
            <PushSubscriptionManager />
            <Routes>
              {/* Pages sans tabs */}
              <Route path="/auth" element={<AuthPlatform />} />
              <Route path="/admin" element={<AdminDashboard />} />

              {/* Pages avec tabs - utilise le Layout */}
              <Route element={<Layout />}>
                <Route path="/" element={<OffersPage isVisitor={true} />} />
                <Route path="/user" element={<OffersPage isVisitor={false} />} />
                <Route path="/posts" element={<ApplicationsPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/sells" element={<CrouVenteForm />} />
              </Route>
            </Routes>
          </NotificationProvider>
        </ProductsProvider>
      </AuthProvider>
    </Router>
  );
}